import React from "react";
import { useDispatch } from 'react-redux'
import styles from "./ProfilePhoto.module.scss";
// import Button from "components/Button/Button";

/**
 * @param {String} [className] - additional className to add
 * @param {String} state - state from parent
 * @param {Function} setState - function to set profile photo in parent state
 * @param {Boolean} [posAbsolute] - whether to use position absolute
 */
const ProfilePhoto = props => {
    const { state, setState } = props;
    const reader = new FileReader();
    const dispatch = useDispatch();

    const handleImage = (state, setState) => event => {
        const file = event.target.files[0];
        if (file.size > 500 * 1024) {
            dispatch({ type: 'SHOW_ALERT', payload: { message: "Image is too large!", color: "danger" } });
        } else {
            reader.readAsDataURL(file);
            reader.onload = function(event) {
                setState({
                    ...state,
                    "profile-photo": event.target.result,
                    "profile-photo-filename": file.name,
                });
            };
        }
    };
    
    const deleteImage = (state, setState) => e => {
        setState({
            ...state,
            "profile-photo": "",
            "profile-photo-filename": "Add/Upload New"
        });
    };
    
    return (
        <div
            className={`${styles["profile-photo"]} ${
                props.posAbsolute ? styles["pos-absolute"] : ""
            }`}
        >
            <div className={styles["photo-container"]}>
                {state["profile-photo"] ? (
                    <img
                        src={state["profile-photo"]}
                        className={styles["profile-photo-image"]}
                        alt=""
                    />
                ) : (
                    <i style={{ fontSize: '9.5rem', color: '#a6ddf3' }} className="fas fa-user-circle" />
                )}
                <span
                    className={styles["delete-photo"]}
                    onClick={deleteImage(state, setState)}
                >
                    <i className="fas fa-trash-alt" />DELETE
                </span>
            </div>

            <label className={styles["file"]}>
                <input accept=".jpg, .jpeg, .png, .gif" type="file" id="file" aria-label="Browse" onClick={(e) => e.target.value = null} onChange={handleImage(state, setState)} />
                <span className={styles["file-custom"]}>{state['profile-photo-filename']}</span>
                <div className={styles["file-text"]}>
                    <span>Upload .jpg, .png or .gif file &lt; 500 KB</span>
                    {/* <Button size="md" color="secondary" text="UPLOAD" icon="fas fa-arrow-circle-up" onClick={(e) => e.preventDefault()} /> */}
                </div>
            </label>

        </div>
    );
};

export default ProfilePhoto;
